
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyKnowledgeService, HotTopicItem } from '../../services/my-knowledge.service';
import { ApiConfigService } from '../../services/api-config.service';

@Component({
  selector: 'app-true-stories',
  templateUrl: './true-stories.component.html',
  styleUrls: ['./true-stories.component.css'],
  standalone: true,
  imports: [CommonModule]
})
export class TrueStoriesComponent implements OnInit {
  stories: HotTopicItem[] = [];
  loading = true;
  error: string | null = null;
  baseUrl: string;

  constructor(private myKnowledgeService: MyKnowledgeService, private apiConfigService: ApiConfigService) {
    this.baseUrl = this.apiConfigService.getApiUrl('');
  }

  ngOnInit(): void {
    this.myKnowledgeService.getHotTopics().subscribe({
      next: (data) => {
        this.stories = data.filter(item => item.field_thematic_area_id === '312');
        this.loading = false;
      },
      error: (err) => {
        this.error = 'Failed to load stories.';
        this.loading = false;
        console.error(err);
      }
    });
  }
}
